import { createApp, defineAsyncComponent } from "vue";
import App from "./App.vue";
import VueHtmlToPaper from "vue-html-to-paper";
import { Core } from "./helpers/core";
// Layout Definition
import { registerLayouts } from "./views/layouts/register";

// import { Dictionary } from "./helpers/dictionary";
//creating app object for furthur usage
const app = createApp(App).use(i18n);
import router from "./router";
import { reactive } from "vue";
import store from "./store";

// import Layouts
registerLayouts(app);

//primevue
import moment from "moment";
import ConfirmationService from "primevue/confirmationservice";
import AutoComplete from "primevue/autocomplete";
import ScrollTop from "primevue/scrolltop";
import Accordion from "primevue/accordion";
import AccordionTab from "./components/core/compat/AccordionTab.vue";
import Avatar from "primevue/avatar";
import AvatarGroup from "primevue/avatargroup";
import Button from "primevue/button";
import Breadcrumb from "primevue/breadcrumb";
import Calendar from "primevue/datepicker";
import Card from "primevue/card";
import Carousel from "primevue/carousel";
import ConfirmPopup from "primevue/confirmpopup";
import Checkbox from "primevue/checkbox";
import Chip from "primevue/chip";
import ColorPicker from "primevue/colorpicker";
import Column from "primevue/column";
import Row from "primevue/row";
import ColumnGroup from "primevue/columngroup";
import ContextMenu from "primevue/contextmenu";
// import DataTable from "primevue/datatable";
import AppDataTable from "./components/core/app-datatable.vue";
import DataView from "primevue/dataview";
// import Dialog from "primevue/dialog";
import Dialog from "./components/core/dialog/Dialog.vue";
import Dropdown from "primevue/select";
import Fieldset from "primevue/fieldset";
import FileUpload from "primevue/fileupload";
import Timeline from "primevue/timeline";
import Inplace from "primevue/inplace";
import InputMask from "primevue/inputmask";
import InputNumber from "primevue/inputnumber";
import InputSwitch from "primevue/toggleswitch";
import InputText from "primevue/inputtext";
import InputGroup from "primevue/inputgroup";
import InputGroupAddon from "primevue/inputgroupaddon";
import Galleria from "primevue/galleria";
import Listbox from "primevue/listbox";
import MegaMenu from "primevue/megamenu";
import AppMenu from "@/components/core/compat/AppMenu.vue";
import Menubar from "primevue/menubar";
import Message from "primevue/message";
import MultiSelect from "primevue/multiselect";
import OrderList from "primevue/orderlist";
import OrganizationChart from "primevue/organizationchart";
import OverlayPanel from "primevue/popover";
import Paginator from "primevue/paginator";
import Panel from "primevue/panel";
import InfoPanel from "@/components/core/info-panel.vue";
import RecurrenceSection from "@/components/shared/recurrence-section.vue";
import PanelMenu from "primevue/panelmenu";
import Password from "primevue/password";
import PickList from "primevue/picklist";
import ProgressBar from "primevue/progressbar";
import Rating from "primevue/rating";
import RadioButton from "primevue/radiobutton";
import Ripple from "primevue/ripple";
import SelectButton from "primevue/selectbutton";
import Slider from "primevue/slider";
import Sidebar from "primevue/sidebar";
import SplitButton from "primevue/splitbutton";
import Steps from "primevue/steps";
import TabMenu from "primevue/tabs";
import TieredMenu from "primevue/tieredmenu";
import Textarea from "primevue/textarea";
import Toast from "primevue/toast";
import ToastService from "primevue/toastservice";
import Toolbar from "primevue/toolbar";
import TabView from "primevue/tabs";
import TabPanel from "primevue/tabpanel";
import Tooltip from "primevue/tooltip";
import ToggleButton from "primevue/togglebutton";
import Tree from "primevue/tree";
import TreeTable from "primevue/treetable";
import ConfirmDialog from "primevue/confirmdialog";
import CascadeSelect from "primevue/cascadeselect";
import Skeleton from "primevue/skeleton";
import Splitter from "primevue/splitter";
import SplitterPanel from "primevue/splitterpanel";
import ProgressSpinner from "primevue/progressspinner";
import Tag from "primevue/tag";
import Knob from "primevue/knob";
import TreeSelect from "primevue/treeselect";
import HelpMessageDialog from "./components/core/help-message-dialog.vue";
import BlockUI from "primevue/blockui";
import Badge from "primevue/badge";
import OverlayBadge from "primevue/overlaybadge";
import Drawer from "primevue/drawer";
import ScrollPanel from "primevue/scrollpanel";
import Chart from "primevue/chart";
// ---------------- Emitter(mitt) Settings ---------------------//
import mitt from "mitt";
const emitter = mitt();

app.config.globalProperties.emitter = emitter; // Make sure this exists!
// ---------------- Emitter(mitt) Settings ---------------------//
// ---------------- Setting subdomain info ---------------------//
app.config.globalProperties.subdomain = Core.getSubdomain();
// app.config.globalProperties.subdomain = Core.move();
app.config.globalProperties.title =
  app.config.globalProperties.subdomain != ""
    ? app.config.globalProperties.subdomain
    : "Epicai";

// NAVIGATION SETTINGS
app.config.globalProperties.config = {
  navigation: {
    perPage: "per-page",
  },
};
// NAVIGATION SETTINGS
// ---------------- Setting subdomain info ---------------------//
import "primeflex/primeflex.css";
import "primeicons/primeicons.css";
import Divider from "primevue/divider";
import "./assets/layout/layout.scss";
// ---------------- Draggable Settings ---------------------//
import draggable from "vuedraggable";
// ---------------- Draggable Settings ---------------------//
// ---------------- Base Forms Actions ---------------------//
import Actions from "./components/core/form/Actions.vue";
// ---------------- Base Forms Actions ---------------------//
// ---------------- Base Forms Components ---------------------//
import BaseInput from "./components/core/form/BaseInput.vue";
import InputBox from "./components/core/form/InputBox.vue";
import BaseTextArea from "./components/core/form/BaseTextArea.vue";
import BaseCheckBox from "./components/core/form/BaseCheckBox.vue";
import ICheckBox from "./components/core/form/ICheckBox.vue";
import IAutoComplete from "./components/core/form/IAutoComplete.vue";
import IDropDown from "./components/core/form/IDropDown.vue";
import ICalendar from "./components/core/form/ICalendar.vue";
import BaseDropdown from "./components/core/form/BaseDropdown.vue";
import BaseRadioButton from "./components/core/form/BaseRadioBtn.vue";
import BaseTreeSelect from "./components/core/form/BaseTreeSelect.vue";
import BaseAutoComplete from "./components/core/form/BaseAutoComplete.vue";
import BaseEditor from "./components/core/form/BaseEditor.vue";
import BaseColorPicker from "./components/core/form/BaseColorPicker.vue";
import BaseMultiSelect from "./components/core/form/BaseMultiSelect.vue";
import ActiveDropdown from "./components/core/form/ActiveDropDown.vue";
import ActiveAutoComplete from "./components/core/form/ActiveAutoComplete.vue";
import TemplateAutoComplete from "./components/core/form/activeAutoComplte/Autocomplete.vue";
import ActiveCheckbox from "./components/core/form/ActiveCheckbox.vue";
import TemplateDropdown from "./components/core/form/TemplateDropDown.vue";
import GroupTemplateDropdown from "./components/core/form/GroupTemplateDropDown.vue";
import FullCalendar from "./components/core/calendar/FullCalendar.vue";
import VuePdf from "vue3-pdfjs";
import VuePaycard from "vue-paycard";
// ---------------- Base Forms Components ---------------------//
import Editor from "primevue/editor";
// import '@fullcalendar/core/main.min.css';
// import '@fullcalendar/daygrid/main.min.css';
// import '@fullcalendar/timegrid/main.min.css';
import PrimeVue from "primevue/config";
import i18n from "./i18n";
import {
  THEME_OPTIONS,
  themeApi,
  getInitialPreset,
  applySavedColorScheme,
} from "./helpers/theme";

app.provide("theme", themeApi);
app.config.globalProperties.$theme = themeApi;

router.beforeEach(function (to, from, next) {
  window.scrollTo(0, 0);
  next();
});
app.config.globalProperties.$appState = reactive({ inputStyle: "outlined" });
app.config.globalProperties.$primevue = reactive({ ripple: true });
app.config.globalProperties.$filters = {
  currencyUSD(value) {
    return "$" + value;
  },
};
app.directive("click-outside", {
  beforeMount(el, binding) {
    el.clickOutsideEvent = function (event) {
      if (!(el === event.target || el.contains(event.target))) {
        binding.value(event, el);
      }
    };
    document.body.addEventListener("click", el.clickOutsideEvent);
  },
  unmounted(el) {
    document.body.removeEventListener("click", el.clickOutsideEvent);
  },
});
app.directive("highlight", {
  beforeMount(el, binding) {
    el.style.background = binding.value;
  },
});

app.use(ToastService);
app.use(ConfirmationService);
app.config.globalProperties.$confirm = {
  require(options = {}) {
    emitter.emit("open-dialog", {
      dialogType: options.dialogType || "confirm",
      header: options.header,
      message: options.message,
      acceptLabel: options.acceptLabel,
      rejectLabel: options.rejectLabel,
      showReject: options.showReject,
      acceptIcon: options.acceptIcon,
      requireLoginOption: options.requireLoginOption,
      requireReason: options.requireReason,
      reasonRequired: options.reasonRequired,
      service: options.service,
      shareLink: options.shareLink,
      accept: options.accept,
      reject: options.reject,
    });
  },
};
app.use(PrimeVue, {
  license: process.env.VUE_APP_PRIMEUI_LICENSE,
  theme: {
    preset: getInitialPreset(),
    options: THEME_OPTIONS,
  },
  locale: {
    accept: "Aceptar",
    reject: "Rechazar",
    startsWith: "Starts with",
    contains: "Contains",
    notContains: "Not contains",
    endsWith: "Ends with",
    equals: "Equals",
    notEquals: "Not equals",
    noFilter: "No Filter",
    lt: "Less than",
    lte: "Less than or equal to",
    gt: "Greater than",
    gte: "Greater than or equal to",
    dateIs: "Date is",
    dateIsNot: "Date is not",
    dateBefore: "Date is before",
    dateAfter: "Date is after",
    clear: "Clear",
    apply: "Apply",
    matchAll: "Match All",
    matchAny: "Match Any",
    addRule: "Add Rule",
    removeRule: "Remove Rule",
    choose: "Choose",
    upload: "Upload",
    cancel: "Cancel",
    dayNames: [
      "Sunday",
      "Monday",
      "Tuesday",
      "Wednesday",
      "Thursday",
      "Friday",
      "Saturday",
    ],
    dayNamesShort: ["S", "M", "T", "W", "T", "F", "S"],
    dayNamesMin: ["S", "M", "T", "W", "T", "F", "S"],
    monthNames: [
      "January",
      "February",
      "March",
      "April",
      "May",
      "June",
      "July",
      "August",
      "September",
      "October",
      "November",
      "December",
    ],
    monthNamesShort: [
      "Jan",
      "Feb",
      "Mar",
      "Apr",
      "May",
      "Jun",
      "Jul",
      "Aug",
      "Sep",
      "Oct",
      "Nov",
      "Dec",
    ],
    today: "Today",
    weekHeader: "Wk",
    firstDayOfWeek: 0,
    dateFormat: "mm/dd/yyyy",
    weak: "Weak",
    medium: "Medium",
    strong: "Strong",
    passwordPrompt: "Enter a password",
    emptyFilterMessage: "No results found",
    emptyMessage: "No available options",
    //...
  },
});
applySavedColorScheme();
app.use(store);
app.use(router);
app.use(VuePaycard);

// Directives
app.directive("tooltip", Tooltip);
app.directive("ripple", Ripple);
// Directives

app.component("Editor", Editor);
app.component("ConfirmDialog", ConfirmDialog);
app.component("ConfirmPopup", ConfirmPopup);
app.component("CascadeSelect", CascadeSelect);
app.component("Tag", Tag);
app.component("Badge", Badge);
app.component("OverlayBadge", OverlayBadge);
app.component("Drawer", Drawer);

app.component("Knob", Knob);
app.component("Accordion", Accordion);
app.component("AccordionTab", AccordionTab);
app.component("AutoComplete", AutoComplete);
app.component("ScrollTop ", ScrollTop);
app.component("Avatar", Avatar);
app.component("Avatargroup", AvatarGroup);
app.component("TreeSelect", TreeSelect);
app.component("Breadcrumb", Breadcrumb);
app.component("Button", Button);
app.component("Calendar", Calendar);
app.component("Card", Card);
app.component("Carousel", Carousel);
app.component("Timeline", Timeline);
app.component("Checkbox", Checkbox);
app.component("Chip", Chip);

app.component("ColorPicker", ColorPicker);
app.component("Column", Column);
app.component("Row", Row);
app.component("ColumnGroup", ColumnGroup);
app.component("ContextMenu", ContextMenu);
app.component("DataTable", AppDataTable);
app.component("DataView", DataView);
app.component("Dialog", Dialog);
app.component("Dropdown", Dropdown);
app.component("Fieldset", Fieldset);
app.component("FileUpload", FileUpload);
app.component("ProgressSpinner", ProgressSpinner);
app.component("Inplace", Inplace);
app.component("InputMask", InputMask);
app.component("InputNumber", InputNumber);
app.component("InputSwitch", InputSwitch);
app.component("InputText", InputText);
app.component("InputGroup", InputGroup);
app.component("InputGroupAddon", InputGroupAddon);
app.component("Galleria", Galleria);
app.component("Listbox", Listbox);
app.component("MegaMenu", MegaMenu);
app.component("Menu", AppMenu);
app.component("Menubar", Menubar);
app.component("Message", Message);
app.component("MultiSelect", MultiSelect);
app.component("OrderList", OrderList);
app.component("OrganizationChart", OrganizationChart);
app.component("OverlayPanel", OverlayPanel);
app.component("Paginator", Paginator);
app.component("Panel", Panel);
app.component("InfoPanel", InfoPanel);
app.component("RecurrenceSection", RecurrenceSection);
app.component("Skeleton", Skeleton);
app.component("PanelMenu", PanelMenu);
app.component("Password", Password);
app.component("PickList", PickList);
app.component("ProgressBar", ProgressBar);
app.component("RadioButton", RadioButton);
app.component("Rating", Rating);
app.component("SelectButton", SelectButton);
app.component("Slider", Slider);
app.component("Sidebar", Sidebar);
app.component("SplitButton", SplitButton);
app.component("Steps", Steps);
app.component("TabMenu", TabMenu);
app.component("TabView", TabView);
app.component("TabPanel", TabPanel);
app.component("Textarea", Textarea);
app.component("TieredMenu", TieredMenu);
app.component("Toast", Toast);
app.component("Toolbar", Toolbar);
app.component("ToggleButton", ToggleButton);
app.component("Tree", Tree);
app.component("TreeTable", TreeTable);
app.component("Splitter", Splitter);
app.component("SplitterPanel", SplitterPanel);
app.component("Divider", Divider);
app.component("ScrollPanel", ScrollPanel);
app.component("Chart", Chart);
app.component("HelpMessageDialog", HelpMessageDialog);

app.config.globalProperties.$filters = {
  dateFormat(date) {
    // new Date(date * 1000);
    return date != null ? moment(date).format("YYYY-MM-DD") : "";
  },
};
app.component("BlockUI", BlockUI);
app.use(VuePdf);

// app.use(VueHtmlToPaper);

// or, using the defaults with no stylesheet
// app.use(VueHtmlToPaper);
const listing = defineAsyncComponent(
  () => import("@/components/core/listing/listing.vue"),
);
const create = defineAsyncComponent(
  () => import("@/components/core/create/create.vue"),
);
const viewJournal = defineAsyncComponent(
  () => import("@/components/core/view-journal/view-journal.vue"),
);
const transactionSummary = defineAsyncComponent(
  () => import("@/components/core/transaction-summary/transaction-summary.vue"),
);
const loader = defineAsyncComponent(
  () => import("@/components/core/gems/loader.vue"),
);
const uploadFile = defineAsyncComponent(
  () => import("@/components/core/files-upload.vue"),
);

const BasicUpload = defineAsyncComponent(
  () => import("@/components/core/basic-upload.vue"),
);
const PrintCheck = defineAsyncComponent(
  () => import("@/components/core/PrintCheck.vue"),
);

app.component("Loader", loader);
app.component("ViewJournal", viewJournal);
app.component("TransactionSummary", transactionSummary);
app.component("Create", create);
app.component("UploadFile", uploadFile);
app.component("BasicUpload", BasicUpload);
app.component("PrintCheck", PrintCheck);

app.component("Listing", listing);
const Icon = defineAsyncComponent(() => import("@/components/core/Icon.vue"));
app.component("Icon", Icon);
const MenuItemIcon = defineAsyncComponent(
  () => import("@/components/core/menu-icon.vue"),
);
app.component("MenuItemIcon", MenuItemIcon);
const Image = defineAsyncComponent(() => import("@/components/core/Image.vue"));
app.component("Image", Image);
app.component("Draggable", draggable);
app
  .component("BaseInput", BaseInput)
  .component("InputBox", InputBox)
  .component("BaseTextArea", BaseTextArea)
  .component("BaseCheckBox", BaseCheckBox)
  .component("ICheckBox", ICheckBox)
  .component("IAutoComplete", IAutoComplete)
  .component("IDropDown", IDropDown)
  .component("ICalendar", ICalendar)
  .component("BaseDropdown", BaseDropdown)
  .component("BaseRadioButton", BaseRadioButton)
  .component("BaseTreeSelect", BaseTreeSelect)
  .component("BaseAutoComplete", BaseAutoComplete)
  .component("BaseEditor", BaseEditor)
  .component("BaseColorPicker", BaseColorPicker)
  .component("BaseMultiSelect", BaseMultiSelect)
  .component("ActiveDropdown", ActiveDropdown)
  .component("TemplateAutoComplete", TemplateAutoComplete)
  .component("FullCalendar", FullCalendar)
  .component("Actions", Actions)
  .component("TemplateDropdown", TemplateDropdown)
  .component("GroupTemplateDropdown", GroupTemplateDropdown)
  .component("ActiveCheckbox", ActiveCheckbox)
  .component("ActiveAutoComplete", ActiveAutoComplete)
  .mount("#app");
